var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearchIcon = function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    "data-name": "Icon/Glyph/25/Search"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0Z",
    "data-name": "Path"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#22cb5b",
    d: "M18.953 19.693a.708.708 0 0 1-.5-.224l-2.443-2.443a7.44 7.44 0 1 1 1.018-1.018l2.444 2.443a.678.678 0 0 1 .17.765.771.771 0 0 1-.689.477M11.28 5.28a6 6 0 0 0-4.24 10.243 6 6 0 0 0 8.483-8.483 5.961 5.961 0 0 0-4.243-1.76",
    "data-name": "Path"
  })));
};
export default SvgSearchIcon;